import React from 'react'
import PropTypes from 'prop-types'

function Toggle({active, text, testid, callback}) {
  const className = active ? 'toggle toggle--active' : 'toggle'

  return (
    <div className={className}>
      {text}
      <button type="button" className="toggle__frame" onClick={callback} data-testid={testid}>
        <div className="toggle__handle" />
      </button>
    </div>
  )
}

Toggle.propTypes = {
  testid: PropTypes.string,
  text: PropTypes.string,
  active: PropTypes.bool.isRequired,
  callback: PropTypes.func.isRequired,
}

export default Toggle
